import { Watch,BaseTLDetailComponent, AxiosResponse, RightHelper, RightService, RightFilter, RoleService, RoleRightFilter, RoleRightService } from "../../../Infrastructure/CorBase/CoreBase";

export default abstract class RoleDetailBase extends BaseTLDetailComponent {
	roleService: RoleService = new RoleService();
	roleRightService: RoleRightService = new RoleRightService();
	rightService: RightService = new RightService();

	protected selectItems: any[] = []; //vyber vice prvku	

	formData = {
		id: 0,
		identifier: '',
		name: '',
		corUserRoleCount: 0,
		roleUser: '',
		description: '',
		idTenant: this.$store.state.idTenant,
		isEditableRow: true
	};

	goBackNotChangeOwnBase() {
		this.goBackNotChange();		
		this.mainDataChangedSub = false;
		this.goBackRightBase();
		this.isCorrectNameBase(this.formData.name);
	}

	protected changeFieldsAfterChangeLanguageBase(value: boolean, oldValue: boolean) {
		if (value !== oldValue) {
			this.fieldsRightModal = this.changeTranslate(this.fieldsRightModal);
			this.filtersRightModal = this.changeTranslate(this.filtersRightModal);
			this.initRight();	
		}		
	}

	protected get showEditButtonChild(): boolean {		
		return this.showEditButton && (this.formData.isEditableRow || RightHelper.currentUserIsSuperUser());
	}

	protected get showEditButtonChildSub(): boolean {
		return (this.formData.isEditableRow || RightHelper.currentUserIsSuperUser());
	}

	protected get showSaveAllBase(): boolean {
		return this.showEditButton && (this.formData.isEditableRow || RightHelper.currentUserIsSuperUser()) && !this.rightNotChangeBase();
	}

	protected get showDeleteButtonChild(): boolean {
		return this.showDeleteButton && this.formData.isEditableRow;
	}

	protected created() {
		this.mainDataChanged = false;
		this.returnRoute = "RoleList";
		super.initializeRights('COR_Role_Create', 'COR_Role_Delete', 'COR_Role_Read', 'COR_Role_Update');
		
	}

	private initRight(): void {
		let filter: RoleRightFilter = new RoleRightFilter(Number(this.objectId));
		this.roleRightService.getAllByFilter(filter).then(res => {
			this.rightAll = res.data;
			this.rightOld = [];
			this.rightAll.forEach(val => this.rightOld.push(Object.assign({}, val)));
		});
	}	

	selectRows(items: any) {
		this.selectItems = [];
		for (var i = 0; i < items.length; i++) {
			this.selectItems.push(items[i]);
		}
	}

	selectedRightItemsBase(selected: any): void {
		for (var i = 0; i < selected.length; i++) {
			var item = this.rightModal.filter(c => c.id == selected[i])[0];
			this.rightAll.push({ id: item.id, identifier: item.identifier, name: item.name, description: item.description });
		}
	}

	protected infoShortInputBase(maxLength: string): void {
		this.showAlertModalWithTitleAndContent(this.$t('global.messageInfo').toString(), this.$t('global.messageShortInput').toString() + maxLength + this.$t('global.messageShortInput2').toString());
	}
	
	protected modalContentDeleteBase(): string {
		var result = this.$t('role.messageQuestionMain').toString();
		if (this.formData.corUserRoleCount > 0) {
			this.isWarningBeforeDelete = true;
			result = this.$t('role.messageQuestionDelete1').toString() + this.formData.corUserRoleCount +
				this.$t('role.messageQuestionDelete2').toString()  + result;
		}
		return result;
	}

	protected mounted() {
		super.mounted();
		this.initRight();
	};

	public  deleteRightBase(item: any): void {
		this.rightAll = (this.rightAll).filter(d => d.id != item) as [];
	}

	protected fetchDataFromServer(): Promise<AxiosResponse<any>> {
		return this.roleService.getById(this.objectId);
	}

	protected fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
		return super.NoCall()
	}

	protected refreshItems(items: any, refreshData: any): any {
		return items;
	}

	protected addNewRightBase(): void {		
		this.initAllRight();
		this.$bvModal.show('rightModal');
	}

	protected processResponse(response: AxiosResponse<any>): void {
		this.formData.id = response.data.id;
		this.formData.identifier = response.data.identifier;
		this.formData.name = response.data.name;
		this.formData.roleUser = response.data.roleUser;
		this.formData.corUserRoleCount = response.data.corUserRoleCount;
		this.formData.description = response.data.description;
		this.formData.idTenant = response.data.idTenant;
		this.formData.isEditableRow = response.data.isEditableRow;
		this.onlyShow = this.onlyShow || !this.formData.isEditableRow;
	}

	protected afterCreate(response: AxiosResponse<any>): void {
		this.formData.id = response.data.id;
		this.formData.isEditableRow = response.data.isEditableRow;
		this.onlyShow = this.onlyShow || !this.formData.isEditableRow;
	}

	protected doAction() {
		if (!this.rightNotChangeBase()) {
			this.saveChangeRightBase();
		}

		if (this.formIsInEditMode || this.styleFormDelete) {
			super.doCRUDActionWithInfoMessage(this.$t('role.messageNew').toString(), this.$t('role.messageEdit').toString(), this.$t('role.messageDelete').toString());
		}
		//this.formIsInEditMode = this.mainDataChangedSub = false;

	}

	protected updateObject(): Promise<AxiosResponse<any>> {
		return this.roleService.update(this.objectId, this.formData)
	}

	protected createObject(): Promise<AxiosResponse<any>> {
		return this.roleService.create(this.formData);
	}

	protected deleteObject(): Promise<AxiosResponse<any>> {
		return this.roleService.delete(this.objectId);
	}

	protected vName: boolean = true;

	protected validate() {
		return !( this.vName);
	}

	protected isCorrectNameBase(value: any) {
		this.vName = value;
	}


	rightAll: any[] = [];
	rightOld: any[] = [];
	rightModal: any[] = [];

	fieldsRight = [	
	//	{ key: 'idRight', label: 'id', sortable: true, sortDirection: 'asc', class: 'text-center' },
		//{ key: 'identifier', label: this.$t('role.filterIdentif'), trans: 'role.filterIdentif', sortDirection: 'asc', sortable: true, class: 'text-center' },
		{ key: 'name', label: this.$t('role.fieldName'), trans: 'role.fieldName', sortable: true, class: 'text-center' },
		{ key: 'description', label: this.$t('role.filterDescription'), trans: 'role.filterDescription', sortDirection: 'asc', sortable: true, class: 'text-center' },
		{ key: 'actions', label: '', class: 'text-right' }
	];

	fieldsRightModal = [
		//{ key: 'identifier', label: this.$t('role.fieldIdentif'), trans: 'role.fieldIdentif', sortable: true, class: 'text-center' },
		{ key: 'name', label: this.$t('role.fieldName'), trans: 'role.fieldName', sortable: true, class: 'text-center' },
		{ key: 'description', label: this.$t('role.fieldDescription'), trans: 'role.fieldDescription', sortable: true, class: 'text-center' },
	];

	filtersRightModal = [
		//{ key: 'identifier', label: this.$t('role.filterIdentif'), trans: 'role.filterIdentif', selected: false, value: null, type: 'text' },
		{ key: 'name', label: this.$t('role.fieldName'), trans: 'role.fieldName', selected: true, value: null, type: 'text', isEditable: true, showOnlyClean: true },
		{ key: 'description', label: this.$t('role.filterDescription'), trans: 'role.filterDescription', selected: false, value: null, type: 'text' }
	];

	protected initAllRight() {
		//pro modal dialog
		this.isBusy = true;
		let filter: RightFilter = new RightFilter();
		this.rightService.getAllByFilter(filter).then(res => {
			var result = [];
			for (var i = 0; i < res.data.length; i++) {
				this.rightModal = [];
				if (this.rightAll.filter(c => c.id == res.data[i].id).length == 0) {
					result.push(res.data[i]);
				}
			}
			this.isBusy = false;
			this.rightModal = result;			
		});
	}


	protected modalNameRight(): string {
		return this.$t('role.modalRight').toString();// + this.formData.name;
	}

	public rightNotChangeBase(): boolean {
		if (this.rightAll.length != this.rightOld.length) {
			return false;
		}
		else {
			for (var i = 0; i < this.rightAll.length; i++) {
				if (this.rightOld.filter(c => c.id == this.rightAll[i].id).length == 0) {
					return false;
				}
			}
		}
		return true;
	}
	protected saveChangeRightBase(): void {
		this.isBusy = true;
		var result = [];
		var forDelete = this.rightOld.filter(c => this.rightAll.filter(a => a.idRight == c.idRight).length == 0);
		for (var i = 0; i < forDelete.length; i++) {
			result.push({ idRight: Number(forDelete[i].id), idRole: this.objectId, helpDelete: true });
		}	
	
		var forAdd =  this.rightAll.filter(c => this.rightOld.filter(a => a.idRight == c.idRight).length == 0);
		for (var i = 0; i < forAdd.length; i++) {
			result.push({ idRight: Number(forAdd[i].id), idRole: this.objectId, helpDelete: false });
		}

		this.roleRightService.update(this.objectId, result).then(res => {
			this.rightOld = [];
			this.rightAll.forEach(val => this.rightOld.push(Object.assign({}, val)));
			this.isBusy = false;
		});
		/*this.formIsInEditMode = this.mainDataChangedSub = false;*/
	}

	protected goBackRightBase(): void {
		this.rightAll = [];
		this.rightOld.forEach(val => this.rightAll.push(Object.assign({}, val)));
	}



}